import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGeosQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGeosQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly geoGroups: ReadonlyArray<{ readonly __typename?: 'YalperGeoGroup', readonly name: string, readonly geos: ReadonlyArray<{ readonly __typename?: 'YalperGeo', readonly id: number, readonly name: string, readonly parentName: string }> }> } | null } | null, readonly allGeos: ReadonlyArray<{ readonly __typename?: 'YalperGeo', readonly id: number, readonly name: string, readonly parentName: string }> };


export const GetGeosDocument = gql`
    query GetGeos {
  currentUser {
    currentCompany {
      geoGroups {
        name
        geos {
          id
          name
          parentName
        }
      }
    }
  }
  allGeos {
    id
    name
    parentName
  }
}
    `;

/**
 * __useGetGeosQuery__
 *
 * To run a query within a React component, call `useGetGeosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeosQuery(baseOptions?: Apollo.QueryHookOptions<GetGeosQueryPage, GetGeosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeosQueryPage, GetGeosQueryVariables>(GetGeosDocument, options);
      }
export function useGetGeosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeosQueryPage, GetGeosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeosQueryPage, GetGeosQueryVariables>(GetGeosDocument, options);
        }
export function useGetGeosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeosQueryPage, GetGeosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeosQueryPage, GetGeosQueryVariables>(GetGeosDocument, options);
        }
export type GetGeosQueryHookResult = ReturnType<typeof useGetGeosQuery>;
export type GetGeosLazyQueryHookResult = ReturnType<typeof useGetGeosLazyQuery>;
export type GetGeosSuspenseQueryHookResult = ReturnType<typeof useGetGeosSuspenseQuery>;
export type GetGeosQueryResult = Apollo.QueryResult<GetGeosQueryPage, GetGeosQueryVariables>;